import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';
import StackedDialogConstants from 'sharedreact/constants/StackedDialogConstants';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

const Content: {
  registeredDialogs: Immutable.List<string>
} = {
  registeredDialogs: Immutable.List()
};

class State extends Immutable.Record(Content) {
}

class StackedDialogStore extends FluxUtils.ReduceStore<State, ActionType> {
  constructor () {
    super(AppDispatcher);
  }

  override getInitialState (): State {
    return new State();
  }

  getLastRegisteredDialog (): string | undefined {
    return this.getState().registeredDialogs.last();
  }

  getStackSize (): number {
    return this.getState().registeredDialogs.size;
  }

  override reduce (state: State, action: ActionType): State {
    switch (action.actionType) {
      case StackedDialogConstants.REGISTER: {
        return state.set('registeredDialogs', state.registeredDialogs.push(action.id));
      }
      case StackedDialogConstants.UNREGISTER: {
        const lastId = state.registeredDialogs.last();
        if (lastId === action.id) {
          return state.set('registeredDialogs', state.registeredDialogs.pop());
        } else {
          // error!
          return state;
        }
      }
      default: {
        return state;
      }
    }
  }
}

export default new StackedDialogStore();
